import React from 'react';
import { Alert, AlertDescription } from '@components/ui/alert';
import { AccountBalanceIcon } from '.';
import { ConfirmationModal } from '../../../components/confirmation-modal/index';
import { Api } from '../../../core/api';
import { AccountOperationDto } from '../../../core/api/WalletClient';
import { injectTSDI } from '../../../core/tsdi';

type Props = {
    onSuccess: () => void;
    operation?: AccountOperationDto;
    openState: [boolean, React.Dispatch<React.SetStateAction<boolean>>];
};

export const OperationDeleteModal = ({
    onSuccess,
    operation,
    openState: [open, setOpen]
}: Props) => {
    const { walletClient } = injectTSDI(Api);

    const handleDelete = async () => {
        if (operation) {
            await walletClient.supportApi.walletSupportControllerDeleteAccountOperation(
                operation.id
            );
        }
        onSuccess();
    };
    return (
        <ConfirmationModal
            open={open}
            title="Revert operation"
            submitHandler={handleDelete}
            onModalClose={() => void setOpen(false)}
            buttonText="Revert"
            destructive
        >
            {operation && (
                <div className="flex flex-col gap-3">
                    <span className="flex items-center gap-1 text-sm">
                        <AccountBalanceIcon
                            balanceKey={operation.moneyStatus}
                        />
                        {operation.moneyStatus}
                    </span>
                    <p className="text-lg">
                        Value: <b>{operation.value.value}</b>
                    </p>
                    <Alert variant="warning">
                        <AlertDescription>
                            Are you sure you want to reject this operation?
                        </AlertDescription>
                    </Alert>
                </div>
            )}
        </ConfirmationModal>
    );
};
